import type { DetailedHTMLProps, InputHTMLAttributes } from 'react';
import { GrCheckboxSelected, GrCheckbox } from 'react-icons/gr';

type CheckboxProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  text: string;
  name: string;
  description?: string;
};

export const Checkbox = ({
  checked,
  onChange,
  name,
  text,
  description,
  value,
}: CheckboxProps) => {
  const Icon = checked ? GrCheckboxSelected : GrCheckbox;

  return (
    <label className={'custom-checkbox'}>
      <input
        checked={checked}
        name={name}
        type={'checkbox'}
        onChange={onChange}
        value={value}
      />

      <Icon aria-hidden={'true'} className={'checkbox'} />

      <span dangerouslySetInnerHTML={{ __html: text }} />

      {description && <p>{description}</p>}
    </label>
  );
};
